module.exports = __webpack_public_path__ + "static/media/Lotad_gaussian2.f779a465.png";